/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'quote': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M3 27.781v13.36h15.39V25.75h-6.406L20.734 7h-5.547L3 27.781zm23.36 0v13.36h15.703V25.75h-6.485L44.718 7h-5.78L26.358 27.781z" _fill="#EF7812"/>'
  }
})
